import { Injectable } from '@angular/core';
import { Toast } from 'bootstrap';

@Injectable()
export class ErrorService{

  private readonly errorToastElement: HTMLElement | undefined;
  private errorToast: Toast | undefined;

  constructor() {
    this.errorToastElement = document.getElementById('errorToast') as HTMLElement;
    this.errorToast = new Toast(this.errorToastElement);
  }

  public showErrorToast(message: string) {
    const toastMsg=  window.document.getElementById('toastMsg') as HTMLElement;
    toastMsg.textContent = message !== undefined ? message : 'Something wrong happened, please check your internet connection.';
    this.errorToast?.show();
  }
}
